async function login(data, urls, Formatter, Network) {
  const url = urls.login
  const response = await sendRequest(data, url, Network)
  const parsedResponse = parseResponse(response, Formatter, Network)
  return parsedResponse
}

async function sendRequest(data, url, Network) {
  const reqData = {
    email: data.email,
    password: data.password,
  }
  const response = await Network.sendPostRequest(url, reqData)
  return response
}

function parseResponse(response, Formatter, Network) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawUser = response.response.user
    const user = Formatter.parseExternalUser(rawUser)

    return {
      success: true,
      user,
    }
  }
  if (response.status.code === 404) {
    return {
      success: false,
      messageId: 'messages.login.userNotFound',
    }
  }
  if (response.status.code === 401) {
    return {
      success: false,
      messageId: 'messages.login.badPassword',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { login }
